module.exports = __webpack_public_path__ + "static/education_card_img2@2x-a241c406934c6df2c57e8182e52d43ef.jpg";